import './ui.css';
import type { ButtonHTMLAttributes } from 'react';
import { Icon, type IconName } from './icons';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: IconName;
  /** Required — used as the accessible label and the hover tooltip. */
  label: string;
  variant?: 'default' | 'ghost';
  size?: 'sm' | 'md';
  iconSize?: number;
}

export function IconButton({
  icon,
  label,
  variant = 'default',
  size = 'md',
  iconSize,
  className,
  ...rest
}: IconButtonProps) {
  const cls = [
    'ui-iconbtn',
    variant === 'ghost' && 'ui-iconbtn--ghost',
    size === 'sm' && 'ui-iconbtn--sm',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button className={cls} aria-label={label} title={label} {...rest}>
      <Icon name={icon} size={iconSize ?? (size === 'sm' ? 15 : 18)} />
    </button>
  );
}
